import { useMemo } from 'react';

import { growerBundlesConfigService } from '../../../../../services/growerBundlesConfig.service';
import { createApiSlice } from '../../../utils/createApiSlice';

const cloneGlobalBundleSlice = createApiSlice({
  reducerPath: ['gff', 'growers', 'bundles', 'cloneGlobalBundle'],
  apiFunction: growerBundlesConfigService.cloneGlobalBundleV2,
  apiArgumentsFn: ({ growerId, bundle }) => [growerId, bundle]
});

const { actions, useApiSelectors } = cloneGlobalBundleSlice;

export const cloneGlobalBundleActions = actions;

export const useCloneGlobalBundleSelectors = () => {
  const { inProgress, success, errorMessage, response, clonedAt } =
    useApiSelectors();

  return useMemo(
    () => ({ inProgress, success, errorMessage, response, clonedAt }),
    [errorMessage, inProgress, response, success, clonedAt]
  );
};

export default cloneGlobalBundleSlice;
